import React from 'react';
import "./Slider.scss";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import Typewriter from "typewriter-effect";

import Slider1 from "../../../../assets/Circular_Carousel-img/slider1.png";
import Slider3 from "../../../../assets/Circular_Carousel-img/slider3.png";
import Slider5 from "../../../../assets/Circular_Carousel-img/slider5.png";

const Slider = () => {
  return (
    <section className="slider-section">
      <div className="layout-s">
        {/* LEFT — Image Carousel */}
        <div className="left">
          <Carousel
            autoPlay
            infinite
            arrows={false}
            showDots={false}
            pauseOnHover={false}
            autoPlaySpeed={2500}
            responsive={{
              desktop: { breakpoint: { max: 3000, min: 1024 }, items: 1 },
              tablet: { breakpoint: { max: 1024, min: 464 }, items: 1 },
              mobile: { breakpoint: { max: 464, min: 0 }, items: 1 },
            }}
          >
            <div className="slide">
              <img src={Slider1} alt="V-Ex Tech Internship" />
            </div>
            <div className="slide">
              <img src={Slider3} alt="Software Training Program" />
            </div>
            <div className="slide">
              <img src={Slider5} alt="Full Stack Development Internship" />
            </div>
          </Carousel>
        </div>

        {/* RIGHT — Description */}
        <div className="right">
          <h2 className="company-title">
            <Typewriter
              options={{
                strings: ['V-Ex Tech Solution'],
                autoStart: true,
                loop: true,
                delay: 60,
                deleteSpeed: 20,
              }}
            />
          </h2>

          <p className="company-desc">
            V-Ex Tech Solution is a leading software development and IT  company
            offering industry-ready internship programs. Our mission is to empower
            students with hands-on coding experience and real-world projects across
            MERN Stack, Python, Data Science, and Software Testing — preparing them
            for successful IT careers.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Slider;
